import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withFormik, Form, Field } from 'formik';
import Yup from 'yup';


class renderForm2 extends Component {
    receiveNextFormNumber = () => {
        this.props.receiveNextFormNumber(1);
    };

    renderFinishedDegree = () => (
        <div className="row form-group">
        <div className={
                this.props.touched.finishedDegree ?
                    (this.props.errors.finishedDegree
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                   What is the highest level of school that you have GRADUATED from? If you’re currently attending university then the highest degree you have attained would be from high school

                    </label>
                </p>
            </div>
            
        <div className="col-sm-4">
            <div className="form-group">
               
                <Field
                    component='select'
                    name='finishedDegree'
                    className="form-control"
                    disabled={!!this.props.isReviewForm}
                >
                    <option value="">Choose</option>
                    <option value="High School">High School</option>
                    <option value="Bachelor's Degree">Bachelor's Degree</option>
                    <option value="Master's Degree">Master's Degree</option>
                    <option value="Doctorate or higher">Doctorate or higher</option>
                    <option value="Other">Other</option>
                </Field>
            </div>
            </div>
            </div>
        </div>
    );
    
    
    renderCGPADegree = () => (
        <div className="row form-group">
        <div className={
                this.props.touched.cgpa ?
                    (this.props.errors.cgpa
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                    For this degree, what was/is your cumulative grade point average (cGPA)?
                    </label>
                </p>
            </div>
            
        <div className="col-sm-4">
            <div className="form-group">
               
                <Field
                    component='select'
                    name='cgpa'
                    className="form-control"
                    disabled={!!this.props.isReviewForm}
                >
                        <option value="">Choose</option>
                        <option value="3.80 - 4.00">3.80 - 4.00</option>
                        <option value="3.50 - 3.79">3.50 - 3.79</option>
                        <option value="3.30 - 3.49">3.30 - 3.49</option>
                        <option value="3.00 - 3.29">3.00 - 3.29</option>
                        <option value="2.80 - 2.99">2.80 - 2.99</option>
                        <option value="2.50 - 2.79">2.50 - 2.79</option>
                        <option value="2.30 - 2.49">2.30 - 2.49</option>
                        <option value="2.00 - 2.29">2.00 - 2.29</option>
                        <option value="1.80 - 1.99">1.80 - 1.99</option>
                        <option value="1.50 - 1.79">1.50 - 1.79</option>
                        <option value="1.30 - 1.49">1.30 - 1.49</option>
                        <option value="1.00 - 1.29">1.00 - 1.29</option>
                        <option value="0.80 - 0.99">0.80 - 0.99 </option>
                        <option value="0.50 - 0.79">0.50 - 0.79</option>
                        <option value="0.30 - 0.49">0.30 - 0.49</option>
                        <option value="0.00 - 0.29">0.00 - 0.29</option>

                </Field>
            </div>
            </div>
            </div>
        </div>
    );
    
    
    renderFinishedDegreeDate = () => (
          <div className="row">
          <div className={
                this.props.touched.finishedDegreeDate ?
                    (this.props.errors.finishedDegreeDate
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                    
                        Which year did you complete this degree in?
                    </label>
                </p>
            </div>
            <div className="col-sm-4">
                <div className="form-group">
                    
                    <Field
                        component="select"
                        name='finishedDegreeDate'
                        className="form-control"
                        disabled={!!this.props.isReviewForm}
                    >

                            <option value="">Choose</option>
                            <option value="2018">2018</option>
                            <option value="2017">2017</option>
                            <option value="2016">2016</option>
                            <option value="2015">2015</option>
                            <option value="2014">2014</option>
                            <option value="2013">2013</option>
                            <option value="2012">2012</option>
                            <option value="2011">2011</option>
                            <option value="2010">2010</option>
                            <option value="2009">2009</option>
                            <option value="2008">2008</option>
                            <option value="2007">2007</option>
                            <option value="2006">2006</option>
                            <option value="2005">2005</option>
                            <option value="2004">2004</option>
                            <option value="2003">2003</option>
                            <option value="2002">2002</option>
                            <option value="2001">2001</option>
                            <option value="2000">2000</option>
                            <option value="1999">1999</option>
                    </Field>
                </div>
            </div>
            </div>
        </div>
    );
    renderFinishedDegreeName = () => (
        <div className="row form-group">
        <div className={
                this.props.touched.finishedDegreeName ?
                    (this.props.errors.finishedDegreeName
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                        What field of study would you categorize this degree in?
                    </label>
                </p>
            </div>
            
        <div className="col-sm-4">
            <div className="form-group">
               
                <Field
                    type="text"
                    name='finishedDegreeName'
                    className="form-control"
                    disabled={!!this.props.isReviewForm}
                />
            </div>
            </div>
        </div>
        </div>
        
        
    );
    renderInstitution = () => (
        <div className="row form-group">
        <div className={
                this.props.touched.institution ?
                    (this.props.errors.institution
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                       Which institution did you complete this degree from?
                    </label>
                </p>
            </div>
            
        <div className="col-sm-4">
            <div className="form-group">
               
                <Field
                    type="text"
                    name='institution'
                    className="form-control"
                    disabled={!!this.props.isReviewForm}
                    onBlur={e => this.props.collapseForm(1)}
                />
            </div>
            </div>
        </div>
        </div>
    );
    renderCurrentEducation = () => (
        <div className="row form-group">
        <div className={
                this.props.touched.currentEducation ?
                    (this.props.errors.currentEducation
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                    Are you currently in school?
                    </label>
                </p>
            </div>
            
        <div className="col-sm-4">
            <div className="form-group">
                
                <Field
                    component='select'
                    name='currentEducation'
                    className="form-control"
                    id="InSchoolSelect"
                    disabled={!!this.props.isReviewForm}
                >
                    <option value="">Choose</option>
                    <option value="No">No</option>
                    <option value="High School">High School</option>
                    <option value="Bachelor's Degree">Bachelor's Degree</option>
                    <option value="Master's Degree">Master's Degree</option>
                    <option value="Doctorate or higher">Doctorate or higher</option>
                    <option value="Other">Other</option>
                </Field>
            </div>
        </div>
        </div>
        </div>
    );
    renderYearOfStudy = ({values, isReviewForm}) => (
        <div className="col-sm-3">
        <div className={
                this.props.touched.yearOfStudy ?
                    (this.props.errors.yearOfStudy
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>Current year of study</label>
                <Field
                    type="text"
                    disabled={
                        values.currentEducation === 'No'
                        || values.currentEducation === ''
                        || !!isReviewForm
                    }
                    name='yearOfStudy'
                    className="form-control InSchoolDependent"
                />
            </div>
        </div>
        </div>
    );
    renderUserCGPA = ({values, isReviewForm}) => (

        <div className="row form-group">
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                    What is your current cumulative grade point average (cGPA)? If you don’t have a cGPA currently, what do you expect at the end of the semester?
                    </label>
                </p>
            </div>
            
        <div className="col-sm-4">
            <div className="form-group">
               
                <Field
                    component='select'
                    name='userCPGA'
                    className="form-control"
                    disabled={!!this.props.isReviewForm}
                >
                        <option value="">Choose</option>
                        <option value="3.80 - 4.00">3.80 - 4.00</option>
                        <option value="3.50 - 3.79">3.50 - 3.79</option>
                        <option value="3.30 - 3.49">3.30 - 3.49</option>
                        <option value="3.00 - 3.29">3.00 - 3.29</option>
                        <option value="2.80 - 2.99">2.80 - 2.99</option>
                        <option value="2.50 - 2.79">2.50 - 2.79</option>
                        <option value="2.30 - 2.49">2.30 - 2.49</option>
                        <option value="2.00 - 2.29">2.00 - 2.29</option>
                        <option value="1.80 - 1.99">1.80 - 1.99</option>
                        <option value="1.50 - 1.79">1.50 - 1.79</option>
                        <option value="1.30 - 1.49">1.30 - 1.49</option>
                        <option value="1.00 - 1.29">1.00 - 1.29</option>
                        <option value="0.80 - 0.99">0.80 - 0.99 </option>
                        <option value="0.50 - 0.79">0.50 - 0.79</option>
                        <option value="0.30 - 0.49">0.30 - 0.49</option>
                        <option value="0.00 - 0.29">0.00 - 0.29</option>

                </Field>
            </div>
            </div>
        </div>
    );

    renderCompletionDate = ({values, isReviewForm}) => (
        <div className="row form-group">
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                    When do you expect to graduate?
                    </label>
                </p>
            </div>
            
            <div className="col-sm-4">
                <div className="form-group">
                    <Field
                        type="text"
                        disabled={
                            values.currentEducation === 'No'
                            || values.currentEducation === ''
                            || !!isReviewForm
                        }
                        name='completionDate'
                        className="form-control InSchoolDependent"
                    />
                </div>
            </div>
        </div>
    );
    renderMajorField = ({values, isReviewForm}) => (
        
        <div className="row form-group">
            <div className="col-sm-4">
                <p className="text-right-md">
                    <label>
                     What field of study would you categorize yourself in?
                    </label>
                </p>
            </div>
            
            <div className="col-sm-4">
                <div className="form-group">
                    <Field
                        type="text"
                        disabled={
                            values.currentEducation === 'No'
                            || values.currentEducation === ''
                            || !!isReviewForm
                        }
                        name='majorField'
                    className="form-control InSchoolDependent"
                    />
                </div>
            </div>
        </div>
        
        
       
    );

    render () {
        const {
            isSubmitting,
            handleSubmit,
            isReviewForm,
            collapsedForms,
             collapseForm,
             clearCollapseForms,
             toggleCollapse,
             touched,
             errors
        } = this.props;
        return (
            <Form action="#" id="submit_form" onSubmit={handleSubmit}>
                <div className="form-wizard">
                    <div className="form-body">
                        <div className={"tab-content "+(isReviewForm ? "review" : "")}>
                            <div className="tab-pane active" id="tab2">
                            
                            
                            <div className={`form-section ${(collapsedForms.indexOf(1) > -1 && !errors.finishedDegree && !errors.finishedDegreeDate && !errors.cgpa && !errors.finishedDegreeName && !errors.institution) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => toggleCollapse(1)}>
                                Previous Education
                                
                                {(touched.finishedDegree && touched.finishedDegreeDate && touched.cgpa && touched.finishedDegreeName && !errors.institution && !errors.finishedDegree && !errors.finishedDegreeDate && !errors.cgpa && !errors.finishedDegreeName && !errors.institution) &&
                                    <i className="zmdi zmdi-chevron-down"></i>
                                    
                                }
                                </h3>
                            <div className="form-section-body" style={{height: (collapsedForms.indexOf(1) > -1 && !errors.finishedDegree && !errors.finishedDegreeDate && !errors.cgpa && !errors.finishedDegreeName && !errors.institution) ? '0px' : 'initial'}}>
                                
                           
                            
                            
                                
                                    <div className="row">
                                        {this.renderFinishedDegree()}
                                        {this.renderFinishedDegreeDate()}
                                        {this.renderCGPADegree()}
                                        {this.renderFinishedDegreeName()}
                                        {this.renderInstitution()}
                                    </div>
                                </div>
                            </div>
                            
                            <div className="form-section">
                                <h3 className="form-heading">Current Education</h3>
                                <div className="form-section-body">
                                    <div className="row">
                                        {this.renderCurrentEducation()}

                                        {this.props.values.currentEducation !== "No" ?
                                            <div>
                                                {this.renderUserCGPA(this.props)}
                                                {this.renderCompletionDate(this.props)}
                                                {this.renderMajorField(this.props)}
                                            </div>
                                        : null}
                                    </div>
                                </div>
                            </div>
                            
                            </div>
                            
                        </div>
                    </div>
                    {
                        !isReviewForm &&
                        <div className="onboarding-form-step form-actions sm-top50">
                            <div className="row">
                                <div className="col-md-12 text-right">
                                    <button className="btn btn-default btn-lg font-16 button-previous"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.props.setPrevStep();
                                            }}
                                    >
                                        <i className="m-icon-swapleft"></i>
                                        Back
                                    </button>
                                    <button
                                        className="btn btn-danger button-next btn-lg font-16"
                                        disabled={isSubmitting}
                                        onClick={e => {
                                        this.props.findError();
                                        this.props.handleSubmit(e);
                                    }}
                                    >
                                        Continue <i className="m-icon-swapright m-icon-white"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Form>
        )
    }
};


const Form2 = withFormik({

    mapPropsToValues({ parentProps,
                         finishedDegree,
                         finishedDegreeDate,
                         finishedDegreeName,
                         institution,
                         currentEducation,
                         yearOfStudy,
                         userCGPA,
                         completionDate,
                         majorField,
                         cgpa})
    {
        return {
            finishedDegree: finishedDegree || parentProps.profile.education[0].finishedDegree || '',
            finishedDegreeDate: finishedDegreeDate || parentProps.profile.education[0].finishedDegreeDate || '',
            finishedDegreeName: finishedDegreeName || parentProps.profile.education[0].finishedDegreeName || '',
            institution: institution || parentProps.profile.education[0].institution || '',
            currentEducation: currentEducation || parentProps.profile.education[0].currentEducation || '',
            yearOfStudy: yearOfStudy || parentProps.profile.education[0].yearOfStudy || '',
            userCGPA: userCGPA || parentProps.profile.education[0].userCGPA || '',
            completionDate: completionDate || parentProps.profile.education[0].completionDate || '',
            majorField: majorField || parentProps.profile.education[0].majorField || '',
            cgpa: cgpa || parentProps.profile.education[0].cgpa || '',
        };
    },
    
    
    validationSchema: Yup.object().shape({
        finishedDegree: Yup.string().required('required'),
        finishedDegreeDate: Yup.string().required('required'),
        finishedDegreeName: Yup.string().required('required'),
        cgpa: Yup.string().required('required'),
        currentEducation: Yup.string().required('required'),

        

    }),
    

    handleSubmit(values, {resetForm, setErrors, setSubmitting, props}) {
        setTimeout(() => {
            if (values.email === 'test@test.io') {
                setErrors({ email: 'This email is already token' })
            }
            else {
                props.onEducationInfoUpdate(
                    {
                        finishedDegree: values.finishedDegree,
                        finishedDegreeDate: values.finishedDegreeDate,
                        finishedDegreeName: values.finishedDegreeName,
                        institution: values.institution,
                        currentEducation: values.currentEducation,
                        yearOfStudy: values.yearOfStudy,
                        userCGPA: values.userCGPA,
                        cgpa: values.cgpa,
                        completionDate: values.completionDate,
                        majorField: values.majorField,
                    }
                );
                props.receiveNextFormNumber(3)
            }
        }, 200)
    }

})(renderForm2);


Form2.propTypes = {

    receiveNextFormNumber: PropTypes.func.isRequired,

    infoEducation: PropTypes.shape({
        finishedDegree: PropTypes.string,
        finishedDegreeDate: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(Date)
        ]),
        finishedDegreeName: PropTypes.string,
        institution: PropTypes.string,
        currentEducation: PropTypes.string,
        yearOfStudy: PropTypes.string,
        userCGPA: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        completionDate: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(Date)
        ]),
        majorField: PropTypes.string,
    }),
};

export default Form2;


// WEBPACK FOOTER //
// ./src/components/onBoarding/Form2.js